/**
 * Created by Lenovo on 2017/5/16.
 */
import ajax from '../../ajax/'
import {bumpUrl} from 'CONFIG/path.config'
class BumpService {
    //协议定义列表
    pframeworkList({data}={}){
        return ajax({
            method:'post',
            url : bumpUrl+'/pframework/list',
            body:data,
        })
    }
    //协议定义删除
    pframeworkDelete(id){
        return ajax({
            method:'get',
            url : bumpUrl+'/pframework/delete/'+id,
        })
    }
    //协议定义添加初始化
    pframeworkAdd(){
        return ajax({
            method:'get',
            url : bumpUrl+'/pframework/add',
        })
    }
    //协议定义编辑初始化
    pframeworkEdit(id){
        return ajax({
            method:'get',
            url : bumpUrl+'/pframework/edit/'+id,
        })
    }
    //协议定义添加编辑提交
    pframeworInsertOrUpdate({data}={}){
        return ajax({
            method:'post',
            url : bumpUrl+'/pframework/insertOrUpdate',
            body:data,
        })
    }

    //模型类别列表
    dvcTypeFetch ({data} = {}) {
        return ajax({
            method: 'post',
            url: bumpUrl+'/dvcType/list',
            body: data
        })
    }
    //模型类别编辑初始化
    dvcTypeToMod (id) {
        return ajax({
            method: 'get',
            url: bumpUrl+'/dvcType/get/'+id
        })
    }
    //模型类别编辑或者新增提交
    dvcTypeInsertOrUpdate ({data} = {}) {
        return ajax({
            method: 'post',
            url: bumpUrl+'/dvcType/insertOrUpdate',
            body: data
        })
    }
    //模型类别删除
    dvcTypeDel (id) {
        return ajax({
            method: 'delete',
            url: bumpUrl+`/dvcType/delete/${id}`
        })
    }


    //协议参数列表
    pparamList ({data} = {}) {
        return ajax({
            method: 'post',
            url: bumpUrl+'/pparam/list',
            body: data
        })
    }

    //协议参数添加初始化
    pparamAdd () {
        return ajax({
            method: 'get',
            url: bumpUrl+'/pparam/add',
        })
    }
    //查询所属模块或者结果赋值模块
    pparamGetMetas(id){
        return ajax({
            method: 'get',
            url: bumpUrl+'/pparam/getMetas/'+id,
        })
    }
    //协议参数编辑初始化
    pparamToMod (id) {
        return ajax({
            method: 'get',
            url: bumpUrl+'/pparam/edit/'+id
        })
    }
    //协议参数编辑或者新增提交
    pparamInsertOrUpdate ({data} = {}) {
        return ajax({
            method: 'post',
            url: bumpUrl+'/pparam/doAdd',
            body: data
        })
    }
    //协议参数删除
    pparamDel (id) {
        return ajax({
            method: 'get',
            url: bumpUrl+`/pparam/delete/${id}`
        })
    }

    //协议解析列表
    panalyzeList ({data} = {}) {
        return ajax({
            method: 'post',
            url: bumpUrl+'/panalyze/list',
            body: data
        })
    }

    //协议解析添加初始化
    panalyzeAdd () {
        return ajax({
            method: 'get',
            url: bumpUrl+'/panalyze/add',
        })
    }
    //协议解析编辑初始化
    panalyzeToMod (id) {
        return ajax({
            method: 'get',
            url: bumpUrl+'/panalyze/edit/'+id
        })
    }
    //协议解析编辑或者新增提交
    panalyzeInsertOrUpdate ({data} = {}) {
        return ajax({
            method: 'post',
            url: bumpUrl+'/panalyze/insertOrUpdate',
            body: data
        })
    }
    //协议解析删除
    panalyzeDel (id) {
        return ajax({
            method: 'get',
            url: bumpUrl+`/panalyze/delete/${id}`
        })
    }

    //模型属性列表
    metaList(){
        return ajax({
            method: 'post',
            url: bumpUrl+'/meta/index',
        })
    }
    //模型属性列表获取属性详情
    metaGetList(id){
        return ajax({
            method: 'get',
            url: bumpUrl+`/meta/get/${id}`
        })
    }
    //模型属性删除
    metaDel (id) {
        return ajax({
            method: 'delete',
            url: bumpUrl+`/meta/doDelete/${id}`
        })
    }
    //模型属性编辑或者新增提交
    metaInsertOrUpdate ({data} = {}) {
        return ajax({
            method: 'post',
            url: bumpUrl+'/meta/doEdit',
            body: data
        })
    }

    //设备在线查询列表
    fetchDvcState ({data} = {}) {
        return ajax({
            method: 'post',
            url: bumpUrl+'/code/list',
            body: data
        })
    }
    //更新设备
    sendCommandByState ({data} = {}) {
        return ajax({
            method: 'post',
            url: bumpUrl+'/code/sendCommandByState',
            body: data
        })
    }

    //空净查询
    dvcBaseList({data}={}){
        return ajax({
            method: 'post',
            url: bumpUrl+'/dvcBase/list',
            body: data
        })
    }
   //空净初始化
   inItAirPurifierList(deviceNo,productId,factoryId){
    return ajax({
        method: 'get',
        url: bumpUrl+'/dvcBase/initDvc?deviceNo='+ deviceNo +'&productId='+ productId+'&factoryId=' +factoryId
    })
}
    //ota列表
    searchFirmwareList({data} = {}) {
        return ajax({
            method: 'post',
            url: bumpUrl+'/firmwares/searchFirmware',
            body: data
        })
    }
    //ota删除
    deleteFirmware(id) {
        return ajax({
            method: 'get',
            url: bumpUrl+'/firmwares/deleteFirmware/'+id
        })
    }
    //设备绑定列表
    searchBindList({data} = {}) {
        return ajax({
            method: 'post',
            url: bumpUrl+'/dvcBase/searchbBindList',
            body: data
        })
    }
    //解绑设备
    dvcBaseUnbindDvc({data} = {}) {
        return ajax({
            method: 'post',
            url: bumpUrl+'/dvcBase/unbindDvc',
            body: data
        })
    }
}

// 实例化后再导出
export default new BumpService()


// WEBPACK FOOTER //
// ./modules/services/purifier/bump/bumpService.js